module.exports = __webpack_public_path__ + "static/media/cardudis_logo.a3393990.png";